import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-limited",
    templateUrl: "./go-limited.component.html"
})


export class GoLimitedComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;

    constructor() {
        super(GO_COMPONENTS.LIMITED);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-limited/go-limited.component.ts